import bytes from 'bytes';
import React, { memo, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { removeDownload } from '../actions/download';
// import { setDownloadPathVisible, setDownloadVisible } from '../actions/layout';
import { setDownloadVisible, setInTimeInstalledSoft } from '../actions/layout';
import { logging } from '../actions/log';
import { installSoft } from '../actions/native';
import { installAndroidSoft } from '../actions/anative';
import {
  DOENLOAD_PREPARING,
  DOWNLOAD_FAILED,
  DOWNLOAD_FINISHED,
  DOWNLOAD_ING,
  INSTALL_ING,
  INSTALL_FAILED,
  INSTALL_FINISHED,
} from '../constants/softstatus';
import { SIM_STATUS_ERROR, SIM_PREPARE_DONE } from '../constants/asimstatus';
import { PCStoreJsBridge } from '../nativeapi';
import './animation.css';
import styles from './DownloadManager.module.less';
import { mySoftKeys } from '../constants/storageKeys';

const selectDownloadSofts = createSelector(
  state => state.download,
  download => download.softs,
);

const selectOtherInfo = createSelector(
  state => state.native,
  native => native.otherInfo,
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectSIMStatus = createSelector(
  state => state.asimstatus,
  asimstatus => asimstatus.status,
);

const logSoftStatus = {}; // 用于打桩判断，防止重复打桩
export default memo(() => {
  const dispatch = useDispatch();
  const downloadSoftDatas = useSelector(selectDownloadSofts);
  const otherInfo = useSelector(selectOtherInfo);
  const logInfoData = useSelector(selectLogInfo);
  const SIMStatus = useSelector(selectSIMStatus); // 模拟器状态

  const handleStopProp = useCallback(ev => {
    ev.stopPropagation();
  }, []);

  const handleDownloadHidden = useCallback(() => {
    dispatch(setDownloadVisible(false));
  }, [dispatch]);

  const handleCancelDownload = useCallback(
    (soft, downloadSofts) => {
      const found = downloadSofts.find(soft_ => soft_.softID === soft.softID);
      // 如果安卓应用，安装状态是下载中才可以取消下载。
      if (soft.androidType === '1' && found && found.status === DOWNLOAD_ING) {
        PCStoreJsBridge.cancelAndroidDownload(soft);
      }
      if (soft.androidType !== '1') {
        PCStoreJsBridge.cancelDownload(soft.softID);
      }
      dispatch(removeDownload(soft.softID));
      // 点击 取消下载 打桩
      dispatch(
        logging({
          category: 'C',
          action: 'Cancel',
          label: '',
          param2: {
            source: 'D_Task',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            softid: soft.androidType === '1' ? soft.packageName : soft.softID,
            softType: soft.androidType === '1' ? '1' : '0',
          },
        }),
      );
    },
    [dispatch],
  );

  const handleRetryInstall = useCallback(
    soft => {
      // 点击 点击重新下载 打桩
      dispatch(
        logging({
          category: 'C',
          action: 'Re_Dl',
          label: '',
          param2: {
            source: 'D_Task',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            softid: soft.androidType === '1' ? soft.packageName : soft.softID,
            softType: soft.androidType === '1' ? '1' : '0',
          },
        }),
      );
      if (soft.androidType === '1') {
        dispatch(installAndroidSoft(soft));
      } else {
        dispatch(installSoft(soft));
      }
    },
    [dispatch],
  );

  const loggingButtonStatus = useCallback((action, soft, status, mes) => {
    if (logSoftStatus[soft.softID] && !logSoftStatus[soft.softID][soft.status]) {
      // 按钮状态变化打桩
      const logParam2 = soft.logInfo || {};
      logParam2.softType = soft.androidType === '1' ? '1' : '0';
      logParam2.status = status;
      logParam2.mes = mes;
      logParam2.speed = soft.AverageDownloadSpeed;
      logParam2.taskid = soft.taskid;
      dispatch(
        logging({
          category: 'R',
          action,
          label: '',
          param2: logParam2,
          param3: soft.bizInfo || null,
        }),
      );
    }
  });

  useEffect(() => {
    downloadSoftDatas.forEach(soft => {
      if (!logSoftStatus[soft.softID]) {
        logSoftStatus[soft.softID] = {};
      }

      if (soft.status === DOWNLOAD_ING) {
        loggingButtonStatus('D_Sd', soft);
        logSoftStatus[soft.softID][soft.status] = true;
      } else if (soft.status === DOWNLOAD_FAILED) {
        loggingButtonStatus('D_Ed', soft, 2, '下载失败');
        // logSoftStatus[soft.softID][soft.status] = true;
        logSoftStatus[soft.softID] = null;
      } else if (soft.status === DOWNLOAD_FINISHED) {
        loggingButtonStatus('D_Ed', soft, 1);
        loggingButtonStatus('I_Si', soft);
        logSoftStatus[soft.softID][soft.status] = true;
      } else if (soft.status === INSTALL_FAILED) {
        loggingButtonStatus('I_Ei', soft, 2, '安装失败');
        // logSoftStatus[soft.softID][soft.status] = true;
        logSoftStatus[soft.softID] = null;
      } else if (soft.status === INSTALL_FINISHED) {
        loggingButtonStatus('I_Ei', soft, 1);
        // logSoftStatus[soft.softID][soft.status] = true;
        logSoftStatus[soft.softID] = null;

        if (soft.androidType === '1') {
          // 判断添加显示小红点
          if (!soft.logInfo || (soft.logInfo && soft.logInfo.type !== 'u')) {
            const spotSoftStr = localStorage.getItem(mySoftKeys.RED_SPOT_SOFT);
            let spotSofts = [];
            if (spotSoftStr) {
              spotSofts = spotSoftStr.split(',');
            }
            if (spotSofts.indexOf(soft.softID) === -1) {
              spotSofts.push(soft.softID);
              localStorage.setItem(mySoftKeys.RED_SPOT_SOFT, spotSofts.join(','));
            }
          }
          // 安卓安装成功后，添加显示安装完成提示。
          dispatch(setInTimeInstalledSoft({ appInfo: soft, time: +new Date() }));
        }
      }
    });
  }, [dispatch, downloadSoftDatas]);

  const judgeDownLoadPath = useCallback(() => {
    if (otherInfo.DownLoadPath) {
      const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g');
      const flag = reg.test(otherInfo.DownLoadPath);
      return flag;
    }
    return false;
  }, [otherInfo]);

  return (
    <div
      className={styles.download}
      onClick={handleStopProp}
      onMouseDown={handleStopProp}
      onTouchStart={handleStopProp}
    >
      <div className="title">
        下载任务管理
        <a onClick={handleDownloadHidden} className="close">
          <i className="iconfont icon-close_small" />
        </a>
      </div>
      {downloadSoftDatas.length > 0 ? (
        <div className="task">
          {downloadSoftDatas.map(v => (
            <div
              key={v.softID}
              className="item"
              style={{
                backgroundImage: `linear-gradient(to right, ${
                  v.status !== DOWNLOAD_ING ? '#ffffff' : '#F2FBF7'
                } ${v.progress}%, #fff ${v.progress}%)`,
              }}
            >
              <div className="soft">
                <div className="soft_logo">
                  <img src={v.logoFile} alt="" />
                  {v.androidType === '1' && <div className="soft_logo_a" />}
                </div>
                <div className="info">
                  <span className="name" dangerouslySetInnerHTML={{ __html: v.softName }} />
                  {v.status !== DOWNLOAD_ING &&
                    v.status !== DOWNLOAD_FINISHED &&
                    v.status !== DOWNLOAD_FAILED && <span className="speed" />}
                  {v.status === DOWNLOAD_ING && (
                    <span className="speed">{bytes(v.DownloadSpeed || 0, 1)}/s</span>
                  )}
                  {(v.status === DOWNLOAD_FINISHED || v.status === INSTALL_ING) && (
                    <span className="installing">正在安装...</span>
                  )}
                  {v.androidType === '1' &&
                    v.status === DOENLOAD_PREPARING &&
                    SIM_STATUS_ERROR.indexOf(SIMStatus) === -1 && (
                      <span className="preparing">准备中..</span>
                    )}
                  {(v.status === DOWNLOAD_FAILED ||
                    (v.androidType === '1' && SIM_STATUS_ERROR.indexOf(SIMStatus) > -1)) && (
                    <span className="error">
                      {judgeDownLoadPath() ? `失败,下载路径有中文,请修改` : '下载失败'}
                    </span>
                  )}
                  {v.status === INSTALL_FAILED && <span className="error">安装失败</span>}
                </div>
              </div>
              <div className="opt">
                {/* 可以关闭任务条件 1.PC软件\安卓软件正在下载 2.PC软件\安卓软件下载失败  3.模拟器下载运行失败 */}
                {(v.status === DOWNLOAD_ING ||
                  v.status === DOWNLOAD_FAILED ||
                  v.status === INSTALL_FAILED ||
                  (v.androidType === '1' && SIM_STATUS_ERROR.indexOf(SIMStatus) > -1)) && (
                  <a
                    className="cancel"
                    onClick={() => {
                      handleCancelDownload(v, downloadSoftDatas);
                    }}
                  >
                    <i className="iconfont icon-stop" />
                  </a>
                )}
                {/* 当安卓软件正在安装，正在准备模拟器环境的时候  显示installing转圈圈 */}
                {v.androidType === '1' &&
                  (v.status === DOWNLOAD_FINISHED ||
                    (v.status === DOENLOAD_PREPARING &&
                      SIMStatus !== SIM_PREPARE_DONE &&
                      SIM_STATUS_ERROR.indexOf(SIMStatus) === -1)) && <i className="installing" />}
                {v.androidType !== '1' && v.status === DOWNLOAD_FINISHED && (
                  <i className="installing" />
                )}
                {/* 可以重试条件 1.PC软件下载失败 2.安卓模拟器下载运行失败  3.安卓软件下载失败 */}
                {((v.androidType !== '1' && v.status === DOWNLOAD_FAILED) ||
                  (v.androidType === '1' &&
                    (v.status === DOWNLOAD_FAILED ||
                      SIM_STATUS_ERROR.indexOf(SIMStatus) > -1))) && (
                  <a
                    className="retry"
                    onClick={() => {
                      handleRetryInstall(v);
                    }}
                  >
                    <i className="iconfont icon-retry" />
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="notask">没有下载任务</div>
      )}

      {/* <div className="tools">
        <span onClick={handleOpenDownloadFolder}>打开下载目录</span>
        <span onClick={handleSetDownloadPath}>设置下载路径</span>
      </div> */}
    </div>
  );
});
